import styled from "@emotion/styled";
import {Typography} from "antd";

export const CentredTitle = styled(Typography.Title)`
  text-align: center;
  padding: 0 !important;
  margin: 0 !important;
`
